import React from 'react';

const PADDING = {
  none: '',
  sm: 'p-4',
  md: 'p-4 sm:p-6',
};

export default function Card({ padding = 'md', interactive = false, as: Comp = 'div', className = '', children, ...rest }) {
  return (
    <Comp
      className={`bg-surface border border-edge rounded-xl shadow-sm ${PADDING[padding] ?? PADDING.md} ${
        interactive
          ? 'transition-all hover:shadow-md hover:border-edge-strong cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
          : ''
      } ${className}`}
      {...rest}
    >
      {children}
    </Comp>
  );
}

Card.Header = function CardHeader({ className = '', children, ...rest }) {
  return (
    <div className={`flex items-center justify-between gap-3 px-4 sm:px-6 py-4 border-b border-edge ${className}`} {...rest}>
      {children}
    </div>
  );
};

Card.Body = function CardBody({ className = '', children, ...rest }) {
  return (
    <div className={`p-4 sm:p-6 ${className}`} {...rest}>
      {children}
    </div>
  );
};

Card.Footer = function CardFooter({ className = '', children, ...rest }) {
  return (
    <div className={`flex items-center justify-end gap-3 px-4 sm:px-6 py-4 border-t border-edge ${className}`} {...rest}>
      {children}
    </div>
  );
};
